import {
  PlaceFeatureDefinition,
  PlaceFeatureGroup,
  PlaceFeatureKey,
} from '../../features/places-features.constants'
import { getFeaturesByGroup } from '../../features/places-features.rules'

export interface PlaceFeatureNode {
  children: PlaceFeatureNode[]
  definition: PlaceFeatureDefinition
}

// Note: hidden switches are left out; a switch whose parent is not part of the group becomes a root
export const getPlaceFeatureTree = (group: PlaceFeatureGroup): PlaceFeatureNode[] => {
  const features = getFeaturesByGroup(group).filter((feature) => !feature.hidden)
  const keys = new Set(features.map(({ key }) => key))

  const build = (definition: PlaceFeatureDefinition): PlaceFeatureNode => ({
    children: features.filter(({ parent }) => parent === definition.key).map(build),
    definition,
  })

  return features.filter(({ parent }) => !parent || !keys.has(parent)).map(build)
}

// Note: a group with a single root (keyless) becomes one card for the root and its plain children, then
// one card per child that has children of its own (a provider with its switches)
export const splitPlaceFeatureTreeByBranch = (tree: PlaceFeatureNode[]): PlaceFeatureNode[] => {
  if (tree.length !== 1) return tree

  const [root] = tree
  const leaves = root.children.filter(({ children }) => children.length === 0)
  const branches = root.children.filter(({ children }) => children.length > 0)

  return [{ ...root, children: leaves }, ...branches]
}

export const collectPlaceFeatureKeys = (nodes: PlaceFeatureNode[]): PlaceFeatureKey[] =>
  nodes.flatMap(({ children, definition }) => [
    definition.key as PlaceFeatureKey,
    ...collectPlaceFeatureKeys(children),
  ])
